module.exports = require('./helpers/bundle-url').getBundleURL('6WWJZ') + "logo.7718c6df.svg";